// const jQuery = require( "jquery" );
import "../styles/app.scss";
import "../node_modules/@splidejs/splide/dist/css/splide.min.css"


import Splide from '@splidejs/splide';
import { toggle } from "./toggle/toggle.js";
import { cookiePolicy } from "./cookiepolicy/cookiepolicy.js";
// import { multilevel } from "./multilevel-nav/multilevel-nav.js";
import { windowheight } from "./windowheight/windowheight.js";
import { scrollanimation } from "./scrollanimation/scrollanimation.js";

const url = 'http://brightwell_staging.local';

var elemental = require("./elem/elem.js");
let CookiesEuBanner = new cookiePolicy();
// let Multilevel = new multilevel(".menu");

var scrollAni = new scrollanimation('[data-type="organism"]');

// Set up Toggles
let toggleNavicon = new toggle(
  "data-linknavicon",
  "data-targetnavicon",
  "active"
);

let factsToggle = new toggle(
  "data-linkfacts",
  "data-targetfacts",
  "active"
);

let registerFormToggle = new toggle(
  "data-linkform",
  "data-targetform",
  "active"
);

let garminToggle = new toggle(
  "data-linkgarmin",
  "data-targetgarmin",
  "active"
);


// Identify window height and add class to body
let WindowHeight = new windowheight();

export function main() {
  // return console.log("Javascript Started");
}


/* Uses .inherit-link to scan for the first link it finds. This makes a div with a link inside clickable */
function inheritLinks() {
  var inheritLinks = document.querySelectorAll(
    ".inherit-link, .bounce-inherit-link"
  );

  let i;
  inheritLinks.forEach(function (links) {
    if (!links.classList.contains("disable__link")) {
      // Search for parent node

      if (links.classList.contains("bounce-inherit-link")) {
        links = links.parentNode;
      }

      // Loop around click event, get ref and redirect window
      links.addEventListener("click", function () {
        let getLink = links.querySelector("a");

        //window.open(getLink.href);

        if (getLink.getAttribute("target") == "_blank") {
          // Identify _blank
          window.open(getLink.href, "_blank");
       
        } else {
          window.location.href = getLink.href;
        }
       
      });
    }
  });
}

inheritLinks();


// Add Splide Slider example (Binds to .splide)
document.querySelectorAll('.splide').forEach((elem) => {
  new Splide( elem, {
    type      : 'loop',
    perPage   : 1,
    autoplay    : true,
    pauseOnHover: false,
    breakpoints: {
      580: {
        perPage   : 1,
      }
    }
  } ).mount();
});


const lightboxes = document.querySelectorAll('.lightbox');


lightboxes.forEach((elem) => {

  elem.parentNode.addEventListener('click', (e) => {
    if(!e.target.classList.contains('overlay')) {
      if(!e.target.classList.contains('atom-icon-cross-white')) {
        elem.parentNode.classList.add('contains-open-lightbox');
        elem.classList.add('active');
      }
    }
  });

  elem.querySelector('.link').addEventListener('click', (e) => {
    elem.parentNode.classList.add('contains-open-lightbox');
    elem.classList.add('active');
  });

  elem.querySelector('.overlay').addEventListener('click', (e) => {
    elem.parentNode.classList.remove('contains-open-lightbox');
    elem.classList.remove('active');
  });


  // elem.querySelector('.overlay .atom-icon-cross-white').addEventListener('click', (e) => {
  //   elem.parentNode.classList.remove('contains-open-lightbox');
  //   elem.classList.remove('active');
  //   console.log('close');
  // });
  
});


const contactpopup = document.querySelectorAll('.contact-popup');

contactpopup.forEach((elem) => {

  elem.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.register-interest-form').classList.add('active');
  });
});

document.querySelector('.register-interest-form .overlay').addEventListener('click', (e) => {
  e.target.parentNode.classList.remove('active');
});

let comms = document.querySelectorAll('.comm-block');

comms.forEach((elem) => {
  elem.addEventListener('click', function() {
    comms.forEach((elem) => {
      elem.classList.remove('active');
    });
    this.classList.add('active');
  })
});

// Garmin popup lightbox

if(document.querySelector('.garmin-download-link')) {

  const garminPopup = document.querySelector('.garmin-download-link');

  garminPopup.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.garmin-download-containers').classList.add('active');
  })

  document.querySelector('.garmin-download-containers .overlay').addEventListener('click', (e) => {
    e.target.parentNode.classList.remove('active');
  });

}

/* Map Functionality */

// Only initialise if map-block exists
if(document.querySelector('.map-block')) {

  // Initialise Tabular Behaviour

  // Select Tabs
  const tabs = document.querySelectorAll('[data-fortab]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', function(e) {

      e.preventDefault();


      // Class add / removal mechanism based on data-attributes
      tabs.forEach((elem) => {
        elem.classList.remove('active');
      });
      
      document.querySelectorAll('[data-istab]').forEach((elem) => {
        elem.classList.remove('active');
      });

      tab.classList.add('active');
      document.querySelector('[data-istab="' + tab.dataset.fortab + '"]').classList.add('active');


      // Run resize-functions to ensure the map fills the correct portion of the viewport
      if (tab.dataset.fortab == "1") {
        map.resize();
      }

      if (tab.dataset.fortab == "2") {
        map2.resize();
      }

    });
  });

  // Initialise Walking Map
  if (document.getElementById("location_1_map")) {
    mapboxgl.accessToken =
      "pk.eyJ1IjoiZXJoLTEyIiwiYSI6ImNqeTl0ZDkybjA3M20zanF0aDg0ajRsZWgifQ.lZ3_LuDLRjyRkLMbzUrqgQ";

      let startingZoom = 16;

      if (window.innerWidth < 960) {
        startingZoom = 14;
    }


    var map = new mapboxgl.Map({
      container: "location_1_map",
      style: "mapbox://styles/erh-12/ckvrwxjzx0hst15rwxspgn6p9", // stylesheet location
      center: [1.286207, 52.051836], // starting position [lng, lat]
      zoom: startingZoom, // starting zoom
    });

    var geojson = {
      type: "FeatureCollection",
      markers: [
        {
          type: "Icon Marker",
          properties: {
            message: "",
            iconSize: [60, 60],
          },
          geometry: {
            type: "Point",
            coordinates: [1.2865584, 52.050773],
          },
        }
      ],
      circles: [
        {
          type: "Map Info",
          properties: {
            message: "15 Minute Walk",
            iconSize: [20, 20],
          },
          geometry: {
            type: "Point",
            coordinates: [1.288742, 52.053621]
          },
        }
      ]
    };

    geojson.markers.forEach(function (marker) {
      // create a DOM element for the marker
      var el = document.createElement("div");

      el.className = "atom-icon-marker";
      el.style.width = marker.properties.iconSize[0] + "px";
      el.style.height = "140px";

      el.addEventListener("click", function () {
        // window.alert(marker.properties.message);
      });

      // add marker to map
      new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
      map.addControl(new mapboxgl.NavigationControl());
      map.scrollZoom.disable();
    });

    geojson.circles.forEach(function(circle, index) {
      var circleMarker = document.createElement("div");
      var message = document.createElement("p");

      circleMarker.style.width = circle.properties.iconSize[0] + "px";
      circleMarker.style.height = circle.properties.iconSize[1] + "px";
      circleMarker.className = "atom-icon-circle-walk";

      message.innerHTML = circle.properties.message;
      message.className = "fs-19 c-secondary ml-100 m-ml-0 mv-0";

      // add to map
      new mapboxgl.Marker(circleMarker).setLngLat(circle.geometry.coordinates).addTo(map);
      new mapboxgl.Marker(message).setLngLat(circle.geometry.coordinates).addTo(map);
    });
  }
  // End Initialise Walking Map
  
  // Initialise Running Map
  if (document.getElementById("location_2_map")) {
    mapboxgl.accessToken =
      "pk.eyJ1IjoiZXJoLTEyIiwiYSI6ImNqeTl0ZDkybjA3M20zanF0aDg0ajRsZWgifQ.lZ3_LuDLRjyRkLMbzUrqgQ";


    let startingZoom = 14;

    if (window.innerWidth < 960) {
      startingZoom = 12;
  }


    var map2 = new mapboxgl.Map({
      container: "location_2_map",
      style: "mapbox://styles/erh-12/ckvs15tf80lxw16quni29mrub", // stylesheet location
      center: [1.286207, 52.051836], // starting position [lng, lat]
      zoom: startingZoom, // starting zoom
    });

    var geojson = {
      type: "FeatureCollection",
      markers: [
        {
          type: "Icon Marker",
          properties: {
            message: "",
            iconSize: [50, 50],
          },
          geometry: {
            type: "Point",
            coordinates: [1.2865584, 52.050773],
          },
        }
      ],
      circles: [
        {
          type: "Map info",
          properties: {
            message: "5K Run",
            iconSize: [20, 20],
          },
          geometry: {
            type: "Point",
            coordinates: [1.308023, 52.052647]
          },
        },
        {
          type: "Map info 2",
          properties: {
            message: "7K Run",
            iconSize: [20, 20],
          },
          geometry: {
            type: "Point",
            coordinates: [1.301032304763794, 52.059806596348444],
          },
        }
      ]
    };

    geojson.markers.forEach(function (marker) {
      // create a DOM element for the marker
      var pinMarker = document.createElement("div");
    
      pinMarker.className = "atom-icon-marker";  
      pinMarker.style.width = marker.properties.iconSize[0] + "px";
      pinMarker.style.height = "140px";
     
      // add marker to map
      new mapboxgl.Marker(pinMarker).setLngLat(marker.geometry.coordinates).addTo(map2);
      map2.addControl(new mapboxgl.NavigationControl());
      map2.scrollZoom.disable();
    });

    geojson.circles.forEach(function(circle, index) {
      var circleMarker = document.createElement("div");
      var message = document.createElement("p");

      circleMarker.style.width = circle.properties.iconSize[0] + "px";
      circleMarker.style.height = circle.properties.iconSize[1] + "px";
      circleMarker.className = "atom-icon-circle-walk  atom-icon-circle-walk-" + index;
      message.innerHTML = circle.properties.message;
      message.className = "fs-19 c-secondary ml-60 m-ml-0 mv-0";
      message.className = "fs-19 c-quaternary ml-60 m-ml-0 mv-0";

      // add to map
      new mapboxgl.Marker(circleMarker).setLngLat(circle.geometry.coordinates).addTo(map2);
      new mapboxgl.Marker(message).setLngLat(circle.geometry.coordinates).addTo(map2);
    });
  }
  // End Initialise Walking Map

}

// Prevent Coming Soon Nav Menu Item to work

let comingSoonNavItem = document.querySelector('.coming-soon');

comingSoonNavItem.addEventListener('click', (e) => {
  e.preventDefault();
  return;
});

// FAQs Accordion
document.addEventListener("DOMContentLoaded", function () {

  const atomMainMenu = document.querySelector('.accordion');
  const menuItems = document.querySelectorAll('.accordion-item');
  
  menuItems.forEach(item => {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      
      menuItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('open');
        }
      });
      
      item.classList.toggle('open');
      const anyOpen = [...menuItems].some(menuItem => menuItem.classList.contains('open'));
      
      if (anyOpen) {
        atomMainMenu.classList.add('accordion-open');
      } else {
        atomMainMenu.classList.remove('accordion-open');
      }
    });
  });
});

// Stats Number Animation
document.addEventListener("DOMContentLoaded", () => {
  const statsBlock = document.querySelector(".stats-block");
  
  if (!statsBlock) return; // Exit if statsBlock is not found
  
  const figures = document.querySelectorAll(".figure");
  
  const animateDigitRoll = (digitSpan, finalDigit, duration, delay) => {
    let startTime = null;
    let rollDuration = duration;
    let spinSpeed = 50; // Initial fast rolling speed
    
    const updateDigit = (timestamp) => {
      if (!startTime) startTime = timestamp;
      let elapsed = timestamp - startTime;
      let progress = elapsed / rollDuration;
      
      if (progress < 1) {
        // Roll between 0-9 randomly
        digitSpan.innerText = Math.floor(Math.random() * 10);
        
        // Slow down over time
        spinSpeed = Math.min(spinSpeed * 1.1, 200);
        setTimeout(() => requestAnimationFrame(updateDigit), spinSpeed);
      } else {
        digitSpan.innerText = finalDigit; // Stop at the final digit
      }
    };
    
    setTimeout(() => {
      requestAnimationFrame(updateDigit);
    }, delay);
  };

  const startAnimation = () => {
    figures.forEach((figure, figureIndex) => {
      let finalValue = figure.dataset.value.toString().split(""); // Convert number to array of digits
      let duration = 2500 + figureIndex * 500; // Base duration increases per item

      figure.querySelectorAll(".digit").forEach((digitSpan, digitIndex) => {
        let finalDigit = finalValue[digitIndex]; // Get the final digit
        let staggerDelay = digitIndex * 150; // Stagger each digit slightly

        animateDigitRoll(digitSpan, finalDigit, duration, staggerDelay);
      });
    });
  };

  // Option 1: Using MutationObserver to detect when .animate__animated is added
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        statsBlock.classList.contains("animate__animated")
      ) {
        startAnimation();
        observer.disconnect(); // Stop observing once animation runs
      }
    });
  });

  observer.observe(statsBlock, { attributes: true });

  // Option 2: Using IntersectionObserver to detect when statsBlock enters viewport
  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && statsBlock.classList.contains("animate__animated")) {
          startAnimation();
          intersectionObserver.disconnect(); // Run animation once
        }
      });
    },
    { threshold: 0.5 } // Adjust threshold as needed
  );

  intersectionObserver.observe(statsBlock);
});